import { ForgotPasswordModal } from "@src/components/Forms/FormElements/ForgotPassword/ForgotPasswordModal";
import { useModal } from "@src/utility_functions/customHooks/useModal";

export const ForgotPasswordLink = (props) => {
  const { openDialog, setModalContent } = useModal();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <button
          type="button"
          style={{ fontSize: "11pt" }}
          onClick={async (event) => {
            event.preventDefault();
            event.stopPropagation();
            setModalContent({
              modalTitle: "Forgot Password",
              dialogWidth: "50%",
              modalContent: <ForgotPasswordModal />,
            });
            if (!props.modalOpen) {
              openDialog();
            }
          }}
        >
          Forgot Password?
        </button>
      </div>
    </>
  );
};
